export const mutations = {
  addEcran (state, ecran) {
    state.ecran = ecran
  },
  setEcran (state, ecran) {
    state.ecran = ecran
  },
  addEcrans(state, ecran){
    state.ecrans = [ ...ecran ]
  },
  addEcranPage(state, ecran){
    state.ecrans = ecran
  },
}
